import React from "react";
import { Link } from "react-router-dom";
import { LuActivity, LuBarChart3, LuPackage } from "react-icons/lu";

import { useAppSelector } from "../../app/hooks";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import { hasPermission, permission } from "../../static/permission";
import { route } from "../../static/route";
import { iconButtonClass } from "./chromeStyles";
import UserMenu from "./UserMenu";

const Header = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;

  const loggingUser = useAppSelector(getLoggingUser);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 flex h-14 md:h-16 shrink-0 items-center gap-2 md:gap-4 border-b border-[hsl(214_32%_91%)] px-3 md:px-4 bg-white shadow-sm">
      <Link
        to={route.dashboard}
        className="flex items-center gap-1 md:gap-2 text-sm md:text-lg font-semibold text-[#113F67] min-w-0 flex-shrink"
      >
        <LuPackage className="h-5 w-5 md:h-6 md:w-6 text-[#34699A] flex-shrink-0" />
        <span className="text-base md:text-xl font-bold truncate">
          {companyName}
        </span>
      </Link>

      <div className="ml-auto flex items-center gap-1 md:gap-4">
        {hasPermission(
          loggingUser?.permissions,
          permission.activityLogsMenu
        ) && (
          <Link to={route.activityLogs} className={iconButtonClass}>
            <LuActivity className="h-4 w-4" />
            <span className="sr-only">એક્ટિવિટી લોગ</span>
          </Link>
        )}

        {hasPermission(
          loggingUser?.permissions,
          permission.businessReportsMenu
        ) && (
          <Link to={route.businessReport} className={iconButtonClass}>
            <LuBarChart3 className="h-4 w-4" />
            <span className="sr-only">બિઝનેસ રિપોર્ટ</span>
          </Link>
        )}

        <UserMenu />
      </div>
    </header>
  );
};
export default Header;
